import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcreLogoSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 26,
	viewBox: "0 0 24 26",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.249 1.98187C20.5323 1.49992 20.1848 0.892578 19.6257 0.892578H14.5198C14.0072 0.892578 13.5329 1.16395 13.2732 1.60584L0.100778 24.0177C-0.182486 24.4997 0.165026 25.107 0.724058 25.107H5.83C6.34257 25.107 6.81683 24.8357 7.07656 24.3938L20.249 1.98187Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.6753 15.7898C17.675 15.7763 17.675 15.7629 17.675 15.7494C17.675 15.7359 17.675 15.7225 17.6753 15.709C17.697 13.9813 19.1044 12.5869 20.8373 12.5869C22.5704 12.5869 23.9778 13.9809 23.9996 15.7086L24 23.6267C24 24.4253 23.3527 25.0727 22.5541 25.0727H19.1212C18.3226 25.0727 17.6753 24.4253 17.6753 23.6268V15.7898Z",
		fill: "white"
	})]
});
export default SvgAcreLogoSmall;
